<template lang="pug">
div
    Modal(:title="$i18n.t('usersmanage.userLoginAndLogoutRecords')" v-model="isModalShow" width="80%")
        Table(:columns="columns" :data="loginAndLogOutRecordsInfosData" height="400")
        div(slot="footer")
            Button(type="primary" @click="isModalShow = false") {{ $t('global.close') }}
    Button(@click="openModal" size="small") {{ $t('usersmanage.loginAndLogoutRecordsInfosBtnText') }}
</template>
<script>
import { getSessionHistory } from "@/libs/sessionHistory";

export default {
    name: "loginAndLogOutRecordsInfosBtn",
    props: ["loginData", "logoutData"],
    data() {
        return {
            isModalShow: false,
            loginAndLogOutRecordsInfosData: [],
            columns: [
                { title: this.$i18n.t("usersmanage.loginDate"), key: "loginDate", width: "250" },
                { title: this.$i18n.t("usersmanage.logoutDate"), key: "logoutDate", width: "250" },
                { title: this.$i18n.t("usersmanage.logoutType"), key: "logoutType", width: "200" },
                {
                    title: this.$i18n.t("usersmanage.sessionDuration"),
                    key: "sessionDuration",
                    width: "250",
                    render: (h, params) => {
                        const loginDate = new Date(params.row.loginDateRaw); // 用 ISO
                        const diffMs = Date.now() - loginDate.getTime();
                        const isOver24h = diffMs > 24 * 3600 * 1000;

                        const text = params.row.sessionDuration || "";
                        return h(
                            "span",
                            {
                                style: {
                                    color: isOver24h && !params.row.logoutDate ? "red" : "inherit",
                                },
                            },
                            text
                        );
                    },
                    renderHeader: (h) => {
                        return h("div", { style: { display: "flex", alignItems: "center" } }, [
                            h("span", this.$i18n.t("usersmanage.userLoginAndLogoutRecords")),
                            h(
                                "Tooltip",
                                {
                                    props: {
                                        content: this.$i18n.t("usersmanage.sessionDurationTooltip"),
                                        placement: "top-end",
                                        maxWidth: "600px",
                                        transfer: true,
                                    },
                                },
                                [
                                    h("Icon", {
                                        props: { type: "ios-alert-outline", size: 16 },
                                    }),
                                ]
                            ),
                        ]);
                    },
                },
                {
                    title: this.$i18n.t("usersmanage.device"),
                    key: "loginDevice",
                    width: "100",
                    render: (h, params) => {
                        let iconType = "";
                        switch (params.row.loginDevice) {
                            case "mobile":
                                iconType = "md-phone-portrait";
                                break;
                            case "tablet":
                                iconType = "md-tablet-portrait";
                                break;
                            case "console":
                                iconType = "md-code-working";
                                break;
                            case "wearable":
                                iconType = "md-watch";
                                break;
                            default:
                                iconType = "md-laptop";
                        }
                        return h("div", { style: { display: "flex", "justify-content": "flex-start" } }, [
                            h("Icon", {
                                props: {
                                    size: "25",
                                    type: iconType,
                                },
                            }),
                        ]);
                    },
                },
                { title: "IP", key: "loginIp", width: "180" },
                { title: "userAgent", key: "loginUserAgent", width: "250" },
            ],
        };
    },
    created() {
        this.getSessionHistory();
    },
    methods: {
        // 整理登入與登出紀錄
        getSessionHistory() {
            this.loginAndLogOutRecordsInfosData = getSessionHistory(
                this.loginData,
                this.logoutData,
                this.$i18n.t.bind(this.$i18n),
                "usersmanage"
            ).reverse();
        },
        openModal() {
            this.getSessionHistory();
            this.isModalShow = true;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/loginAndLogoutRecordsInfosBtn.vue